import { useEffect, useState } from "react";
import "./App.css";
import "./components/common-components/common_css/Common_Form_Css.css";
import "./index.css";

import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";
import About_us from "./components/about_us/About_us";
import Blog from "./components/blog/Blog";
import Blog_inner from "./components/blog/blog_inner/Blog_inner";
import Cart_Products from "./components/cart_Products/Cart_Products";
import Categories from "./components/categories/Categories";
import Certification from "./components/certification/Certification";
import Contact_us from "./components/contact_us/Contact_us";
import Diamond_Education from "./components/diamond_education/Diamond_Education";
import Enggagement from "./components/enggagement/Enggagement";
import Exchange_Policy from "./components/exchange_policy/Exchange_Policy";
import Faq from "./components/faq/Faq";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import My_Account from "./components/my_account/My_Account";
import Cancel_order from "./components/my_orders/cancel_order/Cancel_order";
import Replace_order from "./components/my_orders/cancel_order/Replace_order";
import Return_order from "./components/my_orders/cancel_order/Return_order";
import Cancel_order_details from "./components/my_orders/cancel_order_details/Cancel_order_details";
import Delivered_order from "./components/my_orders/delivered_order/Delivered_order";
import Order_details from "./components/my_orders/order_details/Order_details";
import Replace_order_details from "./components/my_orders/replace_order_details/Replace_order_details";
import Return_order_details from "./components/my_orders/return_order_details/Return_order_details";
import Order_Failed_Page from "./components/order_placed_page/Order_Failed_Page";
import Order_Placed_Page from "./components/order_placed_page/Order_Placed_Page";
import Privacy_Policy from "./components/privacy_policy/Privacy_Policy";
import Proceed_to_Checkout from "./components/proceed_to_Checkout/Proceed_to_Checkout";
import Product_details from "./components/product_details/Product_details";
import Product_Listing_Page_ChildCategory from "./components/product_listing_page_childCategory/Product_Listing_Page_ChildCategory";
import Product_Shape from "./components/product_listing_page_childCategory/Product_Shape";
import Shipping_Policy from "./components/shipping_policy/Shipping_Policy";
import SubCategories from "./components/subcategories/SubCategories";
import Terms_Conditions from "./components/terms_conditions/Terms_Conditions";
import Wallet from "./components/wallet/Wallet";
import Wishlist from "./components/wishlist/Wishlist";
import { checkTokenValidity } from "./features/auth/authSlice";
import { appSetup } from "./features/master/masterSlice";
import { myAccount } from "./features/my_account/Slice";
import { getAllWishlist } from "./features/wishlist/wishlistSlice";
import Shimmer from "./components/Shimmer/Shimmer";

function App() {
  const dispatch = useDispatch();
  const checkToken = () => {
    dispatch(checkTokenValidity());
  };

  useEffect(() => {
    checkToken();
  }, []);

  const isSignIn = useSelector((state) => state.auth.is_signin);

  const [showLoginModal, setShowLoginModal] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    dispatch(appSetup());
    if (isSignIn) {
      dispatch(myAccount());
    }
    if (isSignIn) {
      dispatch(getAllWishlist());
    }
  }, [dispatch, isSignIn]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="global_shimmer">
        <Shimmer type="banner" />
        <div className="container">
          <Shimmer type="section" />
          <Shimmer type="card" count={6} />
        </div>
      </div>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sub-categories/:id" element={<SubCategories />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/product-details/:id" element={<Product_details />} />
        <Route path="/product-cart" element={<Cart_Products />} />
        <Route path="/proceed-to-Checkout" element={<Proceed_to_Checkout />} />
        <Route path="/about-us" element={<About_us />} />
        {/* <Route path="/categories" element={<Shop />} /> */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-inner/:id" element={<Blog_inner />} />
        <Route path="/contact" element={<Contact_us />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/wallet" element={<Wallet />} />

        {/* <Route path="/account" element={<My_Account />} /> */}

        <Route path="/account" element={isSignIn ? <My_Account /> : <Home />} />

        <Route path="/order-details/:id" element={<Order_details />} />
        <Route path="/cancel-order/:id" element={<Cancel_order />} />
        <Route path="/return-order/:id" element={<Return_order />} />
        <Route path="/replace-order/:id" element={<Replace_order />} />
        <Route path="/delivered-order/:id" element={<Delivered_order />} />
        <Route
          path="/return-order-details/:id"
          element={<Return_order_details />}
        />
        <Route
          path="/replace-order-details/:id"
          element={<Replace_order_details />}
        />
        <Route
          path="/cancel-order-details/:id"
          element={<Cancel_order_details />}
        />
        <Route path="/faqs" element={<Faq />} />
        <Route path="/privacy" element={<Privacy_Policy />} />
        <Route path="/shipping" element={<Shipping_Policy />} />
        <Route path="/exchange" element={<Exchange_Policy />} />
        <Route path="/terms" element={<Terms_Conditions />} />

        <Route
          path="/product-listing-child-category/:id"
          element={<Product_Listing_Page_ChildCategory />}
        />

        <Route path="/product-style" element={<Product_Shape />} />

        <Route path="/diamond-education" element={<Diamond_Education />} />

        <Route path="/certifications" element={<Certification />} />

        <Route path="/enggagement" element={<Enggagement />} />
        <Route path="/order-placed" element={<Order_Placed_Page />} />

        <Route path="/order-failed" element={<Order_Failed_Page />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
